import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FolderOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6H19.0605L22.5 2.5605L21.4395 1.5L1.5 21.4395L2.5605 22.5L4.0605 21H21C21.8284 21 22.5 20.3284 22.5 19.5V7.5C22.5 6.67157 21.8284 6 21 6ZM21 19.5H5.56048L17.5605 7.5H21V19.5ZM3 4.5H8.379L10.9395 7.0605L11.379 7.5H13.5V6H12L9.4395 3.4395C9.15826 3.15818 8.77679 3.00008 8.379 3H3C2.17157 3 1.5 3.67157 1.5 4.5V18H3V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FolderOff.vue"]]);
